import { Injectable } from '@angular/core';
import {
  createIcons,
  Eye,
  Pencil,
  Trash2,
  ChevronsLeft,
  ChevronsRight,
  Scan,
  Download,
  MessageCircle,
} from 'lucide';

@Injectable({
  providedIn: 'root',
})
export class LucideService {

  private readonly iconSet = {
    Eye,
    Pencil,
    Trash2,
    ChevronsLeft,
    ChevronsRight,
    Scan,
    Download,
    MessageCircle,
  };

  private responsiveListenerAttached = false;
  private refreshing = false;
  private observer?: MutationObserver;

  initIcons(): void {
    this.loadIcons();
    this.attachResponsiveListener();
  }

  refreshIcons(): void {
    this.loadIcons();
  }

  private loadIcons(): void {
    if (this.refreshing) {
      return;
    }
    this.refreshing = true;
    this.observer?.disconnect();
    try {
      createIcons({
        icons: this.iconSet,
      });
    } finally {
      this.refreshing = false;
      if (this.responsiveListenerAttached && this.observer) {
        this.observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }
    }
  }

  private attachResponsiveListener(): void {
    if (this.responsiveListenerAttached) return;
    this.responsiveListenerAttached = true;

    this.observer = new MutationObserver(() => {
      if (document.querySelector('i[data-lucide]')) {
        this.loadIcons();
      }
    });

    this.observer.observe(document.body, { childList: true, subtree: true });
  }
}